var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 343,
    viewBox: "0 0 512 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958496H512V342.296H0V0.958496Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.058 107.622V185.843C332.058 223.946 384 235.622 384 235.622C384 235.622 435.942 223.947 435.942 185.843V107.622H332.058Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.579 136.065C376.579 143.92 369.935 164.51 361.739 164.51C353.543 164.51 346.899 143.921 346.899 136.065C346.899 128.209 361.739 121.843 361.739 121.843C361.739 121.843 376.579 128.21 376.579 136.065Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.961 151.555C418.355 145.955 420.218 137.77 420.218 133.695C420.218 127.149 411.314 121.843 411.314 121.843C411.314 121.843 402.41 127.149 402.41 133.695C402.41 137.77 404.272 145.955 406.667 151.555L401.526 162.678C404.647 163.892 407.966 164.513 411.314 164.509C414.777 164.509 418.08 163.855 421.102 162.678L415.961 151.555Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.87 185.842C372.87 185.842 365.449 200.064 365.449 214.287H402.55C402.55 200.065 395.129 185.842 395.129 185.842L383.999 178.731L372.87 185.842Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13 185.843V182.288C395.13 176.397 390.147 171.622 384 171.622C377.853 171.622 372.87 176.398 372.87 182.288V185.843H395.13Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0.958496V31.5115L210.833 56.6105H256V115.969H196.897L256 148.805V171.621H229.32L155.826 130.796V171.621H100.174V123.049L12.744 171.621H0V141.068L45.167 115.969H0V56.6105H59.103L0 23.7645V0.958496H26.68L100.174 41.7835V0.958496H155.826V49.5305L243.256 0.958496H256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 0.955566H112V70.2876H0V102.288H112V171.622H144V102.288H256V70.2876H144V0.955566Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.826 115.97L256 171.622V155.885L184.153 115.97H155.826Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.826 115.97L256 171.622V155.885L184.153 115.97H155.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.826 115.97L256 171.622V155.885L184.153 115.97H155.826ZM71.846 115.97L0 155.885V171.622L100.174 115.97H71.846Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.174 56.6076L0 0.955566V16.6926L71.847 56.6076H100.174Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.174 56.6076L0 0.955566V16.6926L71.847 56.6076H100.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.174 56.6076L0 0.955566V16.6926L71.847 56.6076H100.174ZM184.154 56.6076L256 16.6926V0.955566L155.826 56.6076H184.154Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 341.333,
    fill: "white",
    transform: "translate(0 0.958496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/TC.b37e4deca1dab287450a987cf9fbaf34.svg";
export { ForwardRef as ReactComponent };